// src/features/tenants/hooks/useCreateTenant.ts
//
// Submission seam for the "افزودن تننت" flow: owns submitting/error
// state around the real createTenant API call, same
// loading/error-state shape as useTenants. TenantCreateModal reads
// through this hook instead of calling the API directly, so a later
// change to the create contract only touches this file + the API
// function it wraps.

import { useState } from 'react';
import { ApiError } from '@vanialabs/core-api';

import { createTenant } from '../api/tenants.api';
import type { CreateTenantPayload } from '../api/tenants.api';

export function useCreateTenant() {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(payload: CreateTenantPayload) {
    setSubmitting(true);
    setError(null);

    try {
      const tenant = await createTenant(payload);
      return tenant;
    } catch (err) {
      if (err instanceof ApiError) {
        const body = err.body as { detail?: unknown } | undefined;
        if (typeof body?.detail === 'string' && body.detail.trim()) {
          setError(body.detail);
        } else {
          setError('خطا در ایجاد تننت. لطفاً دوباره تلاش کنید.');
        }
      } else {
        setError('خطا در ایجاد تننت. لطفاً دوباره تلاش کنید.');
      }
      throw err;
    } finally {
      setSubmitting(false);
    }
  }

  function resetError() {
    setError(null);
  }

  return {
    submit,
    submitting,
    error,
    resetError,
  };
}
